import {
	createRouter,
	createWebHistory,
	RouteRecordRaw,
} from 'vue-router';
import Home from '../views/HomePage.vue';
import About from '../views/AboutPage.vue';
import Health from '../views/HealthPage.vue';
import HealthMobile from '../views/HealthMobilePage.vue';
import HealthBusiness from '../views/HealthBusinessPage.vue';
import Jvmp from '../views/JvmpPage.vue';
import News from '../views/NewsPage.vue';
import NewsDtl from '../views/NewsDtlPage.vue';
import Contact from '../views/ContactPage.vue';
import Terms from '../views/TermsPage.vue';
import Policy from '../views/PolicyPage.vue';

const routes: Array<RouteRecordRaw> = [
	{
		path: '/',
		name: 'home',
		component: Home,
	},
	{
		path: '/:catchAll(.*)',
		redirect: '/',
	},
	{
		path: '/about',
		name: 'about',
		component: About,
	},
	{
		path: '/health',
		name: 'health',
		component: Health,
	},
	{
		path: '/health_mobile',
		name: 'health_mobile',
		component: HealthMobile,
	},
	{
		path: '/health_business',
		name: 'health_business',
		component: HealthBusiness,
	},
	{
		path: '/jvmp',
		name: 'jvmp',
		component: Jvmp,
	},
	{
		path: '/news',
		name: 'news',
		component: News,
	},
	{
		path: '/news_dtl',
		name: 'news_dtl',
		component: NewsDtl,
	},
	{
		path: '/contact',
		name: 'contact',
		component: Contact,
	},
	{
		path: '/terms',
		name: 'terms',
		component: Terms,
	},
	{
		path: '/policy',
		name: 'policy',
		component: Policy,
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

export default router;
